import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import { property as s } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as o } from "../../core/accessorSupport/decorators/subclass.js";
import e from "../Widget.js";
import { accessibleHandler as i } from "../support/decorators/accessibleHandler.js";
import "../../core/Logger.js";
import { tsx as r } from "../support/jsxFactory.js";
import "../support/widgetUtils.js";
var c = {
  button: "esri-widget--button esri-widget",
  disabled: "esri-disabled",
  interactive: "esri-interactive",
  iconText: "esri-icon-font-fallback-text",
  icon: "esri-icon"
};

var n = /*#__PURE__*/function (_e) {
  _inherits(n, _e);

  var _super = _createSuper(n);

  function n() {
    var _this;

    _classCallCheck(this, n);

    _this = _super.apply(this, arguments), _this.enabled = !0, _this.iconClass = "", _this.title = "";
    return _this;
  }

  _createClass(n, [{
    key: "render",
    value: function render() {
      var _s;

      var t = this.enabled ? 0 : -1,
          s = (_s = {}, _defineProperty(_s, c.disabled, !this.enabled), _defineProperty(_s, c.interactive, this.enabled), _s),
          o = _defineProperty({}, this.iconClass, !!this.iconClass);

      return r("div", {
        bind: this,
        class: this.classes(c.button, s),
        onclick: this._triggerAction,
        onkeydown: this._triggerAction,
        role: "button",
        tabIndex: t,
        title: this.title
      }, r("span", {
        "aria-hidden": "true",
        role: "presentation",
        class: this.classes(c.icon, o)
      }), r("span", {
        class: c.iconText
      }, this.title));
    }
  }, {
    key: "_triggerAction",
    value: function _triggerAction() {
      this.action.call(this);
    }
  }]);

  return n;
}(e);

t([s()], n.prototype, "action", void 0), t([s()], n.prototype, "enabled", void 0), t([s()], n.prototype, "iconClass", void 0), t([s()], n.prototype, "title", void 0), t([i()], n.prototype, "_triggerAction", null), n = t([o("esri.widgets.IconButton")], n);
var a = n;
export { a as default };